<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">  <i class="fa fa-eye"></i> {{entityName | translate}}</h4>
  </div>
  <div class="modal-body custom-height">
    <div class="custom-height-full mt-2">
      <ng2-pdfjs-viewer #pdfViewer
                        [pdfSrc]="urlStream"
                        [download]="false"
                        [print]="false"
                        [openFile]="false"
                        [showSpinner]="true"
                        [viewBookmark]="false"
                        viewerId="documentVisor">
      </ng2-pdfjs-viewer>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success"
            (click)="save()">
      <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE-AND-CLOSE" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger"
            (click)="edit()">
      <i class="fa fa-pen"></i> {{ "BUTTON.CONTINUE-EDITING" | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
